<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-mb-card tm-mb-info-card">
    <v-row class="com-mb-card-contents" no-gutters>
      <v-expansion-panels accordion class="tm-mb-obs-panel">
        <v-expansion-panel>
          <v-expansion-panel-header class="tm-mb-obs-panel-header" expand-icon="arrow_drop_down">
            <v-row class="tm-mb-obs-panel-content" no-gutters>
              <div class="tm-mb-obs-panel-item">
                <span class="tm-mb-rvrnm">
                  {{ tmScamList.scamDetailInfo.scamNm }}
                </span>
              </div>
              <div class="tm-mb-obs-panel-item">
                <span class="tm-mb-rvrnm">
                  {{ tmScamList.scamDetailInfo.rsysNm }}{{ text.rsys }}
                </span>
              </div>
              <div class="tm-mb-obs-panel-item">
                <span class="tm-mb-rvrnm">
                  {{ tmScamList.scamDetailInfo.rvrNm }}
                </span>
              </div>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="tm-mb-obs-content">
            <v-list dense class="tm-mb-obs-content-v-list">
              <!-- 観測所情報 -->
              <v-list-item
                v-for="(item, index) in tmScamList.obsInfo"
                :key="`obs-${index}`"
                class="tm-mb-obs-content-v-list-item"
                v-show="!item.notMb"
              >
                <v-list-item-content
                  class="tm-mb-obs-content-v-list-item-content"
                  >{{ item.title }}</v-list-item-content
                >
                <v-list-item-content
                  v-if="item.itmkndCd && item.value !== null"
                >
                  <div
                    v-if="item.value[0]"
                    class="tm-mb-link tm-mb-obs-content-v-list-item-content"
                    @click="
                      clickObsList(
                        item.ofcCd[0],
                        item.itmkndCd[0],
                        item.obsCd[0]
                      )
                    "
                  >
                    {{ item.value[0] }}
                    <span class="list-value">{{ item.code[0] }}</span>
                  </div>
                  <div
                    v-if="item.value[1]"
                    class="tm-mb-link tm-mb-obs-content-v-list-item-content"
                    @click="clickSwObsList(item.ofcCd[1], 300, item.obsCd[1])"
                  >
                    {{ item.value[1] }}
                    <span class="list-value">{{ item.code[1] }}</span>
                  </div>
                </v-list-item-content>
                <v-list-item-content
                  v-else-if="item.itmkndCd && item.value === null"
                >
                  <div>
                    {{ noData }}
                  </div>
                </v-list-item-content>
                <v-list-item-content
                  class="tm-mb-obs-content-v-list-item-content"
                  v-else
                >
                  <div>
                    <span class="list-value">{{ item.value }}</span>
                    <span class="list-unit">{{ item.unit }}</span>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]簡易カメラ 観測所情報カード
 * TmScamInfo.vue
 * @author ILUKE
 */

export default {
  name: "tm-scam-info",
  data() {
    return {
      /** 文字列リソース */
      text: {
        info: "お知らせ",
        obsInfo: "観測所情報",
        obsType: "河川カメラ",
        rsys: "水系",
      },
      noData: "--",
    };
  },
  created() {
    this.$store.dispatch("map/getObsScamInformation", {
      scamId: this.$store.state.Telemeter.selectedTmParam.scamId,
    });
  },
  computed: {
    /**
     * 通常水位情報 取得
     */
    tmScamList: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /**
     * お知らせ情報の中で緊急度が一番高い１レコードのみ取得
     */
    tmScamInfo: {
      get() {
        return this.$store.state.map.tmInfo;
      },
    },
  },
  methods: {
    /** [MB]個別観測所画面を縮小する */
    tmObsSetReducation() {
      this.$store.commit("Telemeter/setMbTmObsIsExpansion", false);
    },
    /** 観測所リンク */
    clickObsList(ofcCd, itmkndCd, obsCd) {
      this.$log.debug(
        "[rp/TmList] clickObsList(" + ofcCd + "," + itmkndCd + "," + obsCd + ")"
      );
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: ofcCd,
        itmkndCd: itmkndCd,
        obsCd: obsCd,
      });
      // 画面遷移
      this.routerPushTm("/mb/tm");
    },
    /** 危機管理観水位測所画面へ遷移 */
    clickSwObsList(swofcCd, itmkndCd, swobsCd) {
      this.$log.debug(
        "[rp/TmList] clickSwObsList(" +
          swofcCd +
          "," +
          itmkndCd +
          "," +
          swobsCd +
          ")"
      );
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: null,
        itmkndCd: 300,
        obsCd: null,
      });
      this.$store.commit("Swin/setSelectedSwParam", {
        swofcCd: swofcCd,
        itmkndCd: itmkndCd,
        swobsCd: swobsCd,
      });
      // 画面遷移
      this.routerPushTmSw("/mb/tm");
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
